var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    viewBox: "0 0 16 16",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    fill: "#141415",
    r: 7.5,
    stroke: "#64ffa1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.7 2c.484.385.92.826 1.3 1.315l-6.015 6.003-2.134-2.13v3.888c0 .51-.414.924-.925.924-.512 0-.926-.414-.926-.924v-6.005c0-.51.414-.924.926-.924.043 0 .086.003.128.01.235 0 .47.09.65.27l2.281 2.278zm-1.695 8.135c.516 0 .934.418.934.933s-.418.932-.934.932-.934-.417-.934-.932.418-.933.934-.933zm0-2.33c.516 0 .934.417.934.932s-.418.932-.934.932-.934-.417-.934-.932.418-.932.934-.932z",
    fill: "#64ffa1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMint);
export default __webpack_public_path__ + "static/media/mint.7f47eefaf71d914324595e7bacb7a4b6.svg";
export { ForwardRef as ReactComponent };